// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/search-x.js';

import { paths } from '../generated/search-x';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('search-x', Original, paths);
